import React from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";
import { COURSES } from "../mock";

export default function FeaturedCourses() {
  return (
    // <section className="py-24 bg-[var(--paper)] -mt-[120px]">
    //   <div className="max-w-7xl mx-auto px-6">
    //     <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
    //       <div>
    //          <div className="text-center">
    //         <SectionLabel>Featured Courses</SectionLabel>
    //         {/* <h2 className="mt-5 font-display text-[38px] lg:text-[48px] leading-[1.05] font-bold">
    //           Learn from a curriculum <br />that <span className="italic text-[var(--terracotta)]">honours tradition</span> <br />and embraces the future.
    //         </h2> */}
    //       </div>
    //       {/* <p className="max-w-md text-[15.5px] text-[var(--ink)]/70">
    //         From foundation courses aligned with NEP 2020 to doctoral programmes with international
    //         collaboration — explore an academic portfolio built for every ambition.
    //       </p> */}
    //     </div>

    //     <DiamondBorder className="my-4" />
    //     </div>

    //     <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-5">
    //       {COURSES.map((c, i) => (
    //         <article
    //           key={c.title}
    //           className="group relative rounded-2xl bg-white px-7 pt-7 pb-4 border border-[var(--cream-deep)] card-lift overflow-hidden"
    //         >
    //           <div className="absolute -right-8 -top-4 h-28 w-28 rounded-full bg-[var(--terracotta)]/5 group-hover:bg-[var(--terracotta)]/10 transition-colors" />
    //           <div className="flex items-center justify-between -top-4">
    //             <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-[var(--saffron)]/15 text-[var(--terracotta-deep)] px-3 py-1 text-[11.5px] font-semibold tracking-wider">
    //               <Sparkles size={12} /> {c.tag}
    //             </span>
    //             <span className="text-[12px] text-[var(--ink)]/50">{c.count}</span>
    //           </div>
    //           <h3 className="mt-5 font-display font-bold text-[22px] text-[var(--ink)] leading-tight">
    //             {c.title}
    //           </h3>
    //           <p className="mt-3 text-[14px] leading-relaxed text-[var(--ink)]/70">{c.desc}</p>
    //           {/* <a href="#" className="mt-6 inline-flex items-center gap-1.5 text-[13.5px] font-semibold text-[var(--terracotta)] link-sweep">
    //             View programmes <ArrowUpRight size={15} />
    //           </a> */}
    //           <div className="absolute left-0 bottom-[10px]  h-1 w-0 bg-gradient-to-r from-[var(--terracotta)] to-[var(--saffron)] group-hover:w-full transition-all duration-500" />
    //         </article>
    //       ))}
    //     </div>

    //     <div className="mt-12 text-center">
    //       {/* <a href="#all" className="btn-outline">Browse all courses <ArrowUpRight size={16} /></a> */}
    //     </div>
    //   </div>
    // </section>
    <></>
  );
}
